import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { RestService } from '../rest/rest.service';
import { AccountPreferences, UserPreferences, ExtraParametersPreferences } from './preferences.domain';

/**
 * Preferences Rest Service
 *
 * Get/Update user and account preferences
 *
 */
@Injectable({
  providedIn: 'root'
})
export class PreferencesRestService {
  private readonly restService = inject(RestService);

  /**
   * Get user preference
   * If user perfernce is not in preload preferences
   * Load from server
   *
   * @param preferenceKeys: the preference keys
   * If preferenceKeys is undefined returns data from server
   * @returns: user preferences
   */
  getUserPreferences(): Observable<UserPreferences> {
    return this.restService.getResource('customer.user').get<UserPreferences>();
  }

  /**
   * Update user preference
   *
   * @param preferences: the preference keys
   * @param extraParameters: extra parameters required by API. Refer to ExtraParametersPreferences interface
   * @returns: user preferences
   */
  updateUserPreferences(userPreferences: UserPreferences, extraParameters?: ExtraParametersPreferences): Observable<void> {
    let body = {
      preferences: userPreferences
    };
    if (extraParameters !== undefined) {
      body = Object.assign(body, extraParameters);
    }

    return this.restService.getResource('customer.updateUserPreferences').post(body);
  }

  /**
   * Get account preference
   *
   * @param account: account object
   * @param preferenceKey: preference key to load
   * If preference key is not preloaded, will load from server
   * @returns: account preferences
   */
  getAccountPreferences(): Observable<AccountPreferences> {
    return this.restService.getResource('customer.allAccounts').get<AccountPreferences>();
  }

  /**
   * Update account preference
   *
   * @param account: account object
   * @param preferences: preference key to update
   * @returns: account preferences
   */
  updateAccountPreferences(accountPreferences: AccountPreferences): Observable<void> {
    const body = {
      preferences: accountPreferences
    };
    return this.restService.getResource('customer.updateAccountPreferences').put(body);
  }
}

